
<template>
  <div>
    <article
      :href="itemLink"
      @click.prevent="goToDetail"
      class="product-miniature js-product-miniature card shadow-lg"
    >
      <div class="thumbnail-container">
        <div class="product-image">
          <a class="thumbnail product-thumbnail product-image-a" style="display: flex !important;">
            <img class="img-fluid" :src="primaryImageUrl" alt />
            <span class="product-additional"></span>
          </a>

          <div class="functional-buttons clearfix">
            <!-- compare -->
            <div class="compare">
              <a class="leo-compare-button btn-primary btn-product btn" href="javascript:void(0)">
                <i class="icon-btn-product icon-compare material-icons">&#xE915;</i>
                <span class="name-btn-product">Add to Compare</span>
              </a>
            </div>

            <!-- cart -->
            <div class="button-container cart">
              <button
                class="btn btn-product add-to-cart leo-bt-cart"
                type="button"
              >
                <i class="icon-btn-product icon-cart material-icons shopping-cart">&#xE547;</i>
                <span class="name-btn-product">Add to cart</span>
              </button>
            </div>

            <!-- wishlist -->
            <div class="wishlist">
              <a class="leo-wishlist-button btn-product btn-primary btn" href="javascript:void(0)">
                <i class="icon-btn-product icon-wishlist material-icons">&#xE87D;</i>
                <span class="name-btn-product">Add to Wishlist</span>
              </a>
            </div>

            <!-- quickview -->
            <div class="quickview no-variants hidden-sm-down">
              <a href="#" class="quick-view" title="Quick view">
                <i class="material-icons search">&#xE8B6;</i>
                <span>Quick view</span>
              </a>
            </div>
          </div>
        </div>

        <!-- product info -->
        <div class="product-meta">
          <h3 class="h3 product-title">
            <a href="#">{{ cleanTitle }}</a>
          </h3>

          <div
            class="product-price-and-shipping has_discount"
            v-if="total.discountedPrice > 0"
          >
            <span class="regular-price">{{ total.salesPrice }}৳</span>
            <span class="discount-percentage">-20%</span>
            <span class="price">{{ total.discountedPrice }}৳</span>
          </div>

          <div class="product-price-and-shipping" v-else>
            <span class="price">{{ total.salesPrice }}৳</span>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script setup>
import { ref, toRef, computed } from "vue";
import { useRouter } from "vue-router";
import { useItemDto } from "@/composables/useItemDto";

const router = useRouter();

const props = defineProps({
  item: { type: Object, default: null },
});

const itemRef = toRef(props, "item");
const {
  id,
  primaryImageUrl,
  title,
  price,
  discountedSalesPrice,
} = useItemDto(itemRef.value);

const itemLink = computed(() =>
  id.value ? `/products/${id.value}` : "#"
);

const goToDetail = () => {
  if (id.value) router.push(`/products/${id.value}`);
};

const cleanTitle = computed(() => {
  return (title.value || "").replace(/&amp;/g, "&");
});

// ✅ total price calculation
const total = computed(() => {
  const salesPrice = Number(price.value) || 0;
  const discountedPrice = Number(discountedSalesPrice.value) || 0;

  return {
    salesPrice,
    discountedPrice,
  };
});
</script>

<style lang="scss" scoped>
.card {
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  }
}

.product-image-a {
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}
</style>

<!-- <template>
    <div class="">
        <article 
            :href="itemLink"
            @click.prevent="goToDetail"
            class="product-miniature js-product-miniature card shadow-lg">
            <div class="thumbnail-container">
                <div class="product-image">
                    <a
                        class="thumbnail product-thumbnail product-image-a">
                        <img class="img-fluid"
                            :src="primaryImageUrl"
                            alt>
                        <span class="product-additional" data-idproduct="2"></span>
                    </a>

                    <div class="functional-buttons clearfix">

                        <div class="compare">
                            <a class="leo-compare-button btn-primary btn-product btn" href="javascript:void(0)"
                                data-id-product="2" title="Add to Compare">
                                <span class="leo-compare-bt-loading cssload-speeding-wheel"></span>
                                <span class="leo-compare-bt-content">
                                    <i class="icon-btn-product icon-compare material-icons">&#xE915;</i>
                                    <span class="name-btn-product">Add to
                                        Compare</span>
                                </span>
                            </a>
                        </div>
                        <div class="button-container cart">
                            <form >
                                <input type="hidden" name="token" value="db62e42ed679a2b3256f637c8b160d22">
                                <input type="hidden" value="1196" class="quantity_product quantity_product_2"
                                    name="quantity_product">
                                <input type="hidden" value="1" class="minimal_quantity minimal_quantity_2"
                                    name="minimal_quantity">
                                <input type="hidden" value="9" class="id_product_attribute id_product_attribute_2"
                                    name="id_product_attribute">
                                <input type="hidden" value="2" class="id_product" name="id_product">
                                <input type="hidden" name="id_customization" value class="product_customization_id">
                                <input type="hidden" class="input-group form-control qty qty_product qty_product_2"
                                    name="qty" value="1" data-min="1">
                                <button class="btn btn-product add-to-cart leo-bt-cart leo-bt-cart_2"
                                    data-button-action="add-to-cart" type="submit">
                                    <span class="leo-loading cssload-speeding-wheel"></span>
                                    <span class="leo-bt-cart-content">
                                        <i class="icon-btn-product icon-cart material-icons shopping-cart">&#xE547;</i>
                                        <span class="name-btn-product">Add
                                            to cart</span>
                                    </span>
                                </button>
                            </form>
                        </div>

                        <div class="wishlist">
                            <a class="leo-wishlist-button btn-product btn-primary btn" href="javascript:void(0)"
                                data-id-wishlist data-id-product="2" data-id-product-attribute="9" title="Add to Wishlist">
                                <span class="leo-wishlist-bt-loading cssload-speeding-wheel"></span>
                                <span class="leo-wishlist-bt-content">
                                    <i class="icon-btn-product icon-wishlist material-icons">&#xE87D;</i>
                                    <span class="name-btn-product hidden hide text-remove">Remove
                                        from Wishlist</span>
                                    <span class="name-btn-product text-add">Add
                                        to Wishlist</span>
                                </span>
                            </a>
                        </div>

                        <div class="quickview no-variants hidden-sm-down">
                            <a href="#" class="quick-view" data-link-action="quickview" title="Quick view">
                                <span class="leo-quickview-bt-loading cssload-speeding-wheel"></span>
                                <span class="leo-quickview-bt-content">
                                    <i class="material-icons search">&#xE8B6;</i>
                                    <span>Quick view</span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="product-meta">

                    <h3 class="h3 product-title" itemprop="name"><a
                            href="#">{{ title }}</a></h3>

                    <div class="product-price-and-shipping has_discount" v-if="total.discountedPrice">
                        <span class="sr-only">Regular price</span>
                        <span class="regular-price">{{total.salesPrice}}/-</span>
                        <span class="discount-percentage">-20%</span>
                        <span class="sr-only">Price</span>
                        <span class="price" itemprop="offers">
                            <span itemprop="priceCurrency" content="USD"></span><span itemprop="price"
                                content="28.72">{{total.discountedPrice}}/-</span>
                        </span>
                    </div>
                    <div class="product-price-and-shipping has_discount" v-else>
                        <span class="sr-only">Price</span>
                        <span class="price" itemprop="offers">
                            <span itemprop="priceCurrency" content="USD"></span><span itemprop="price"
                                content="28.72">{{total.salesPrice}}/-</span>
                        </span>
                    </div>
                </div>
            </div>
        </article>
    </div>
</template>

<script setup>
import { useItemDto } from "@/composables/useItemDto";
// import { useCurrenciesStore } from "@/stores/currencies-store";
// import { useGlobalDiscountStore } from "@/stores/global-discount-store";

// const globalDiscountStore = useGlobalDiscountStore();
// const currenciesStore = useCurrenciesStore();
const router = useRouter();

const toaster = ref(null);

const props = defineProps({
    item: {
        type: Object,
        default: null,
    },
    isColor: {
        type: Boolean,
        default: true,
    },
    isNewBadge: {
        type: Boolean,
        default: true,
    },
    isWishIconVisible: {
        type: Boolean,
        default: true,
    },
});

const itemRef = toRef(props, "item");
const {
    id,
    sourceType,
    primaryImageUrl,
    primaryImages,
    title,
    model,
    price,
    discountedSalesPrice,
    subscriptionPrice,
} = useItemDto(itemRef.value);
const itemContainer = ref(null);
const activeWishListLocale = ref(false);
const showImage = ref(false);

const colors = ref(["#000", "#766C69", "#302A27"]);

const itemLink = computed(() => {
    let link = "#";
    let ids = id.value ?? "";
    if (ids) {
        link = `/products/${id.value}`;
    }
    return link;
});

const goToDetail = () => {
    let ids = itemRef.value?.id ?? "";
    router.push(`/products/${ids}`);
};

// const getHight = computed(() => {
//     if (itemContainer.value?.offsetWidth) {
//         return itemContainer.value.offsetWidth < 700
//             ? itemContainer.value.offsetWidth
//             : 600;
//     }
//     return 0;
// });

// const addToWishList = async () => {
//     let title = props.item.title;
//     let data = {
//         itemId: props.item.id,
//         skuCode: props.item.code,
//         wishlistId: "",
//     };

//     wishlistsClient.create(data).then((res) => {
//         if (res.status == 201 && !res.networkError) {
//             toaster.value.success(`${title} Successfully added to Wishlist`, {
//                 duration: 1500,
//             });
//             wishlistStore.updateList(data);
//             activeWishListLocale.value = true;
//         } else {
//             toaster.value.error(`${title} Failed to add Wishlist`, {
//                 duration: 1500,
//             });
//         }
//     });
// };

// const isActive = computed(() => {
//     let active = false;

//     if (activeWishListLocale.value) {
//         active = true;
//     } else if (props.item && props.item.id) {
//         let isExists = wishlistStore.isExists(props.item.id, props.item.code);
//         if (isExists) {
//             active = true;
//         }
//     }
//     return active;
// });

// const itemCurrency = computed(() => {
//     let currency = "BDT";
//     if (
//         currenciesStore.country &&
//         currenciesStore.country.currency &&
//         currenciesStore.country.currency.length > 0
//     ) {
//         currency = currenciesStore.country.currency;
//     }

//     return currency;
// });

// const globalDiscount = computed(() => {
//     if (!props.item?.id) {
//         return 0;
//     }
//     if (discountedSalesPrice.value > 0) {
//         return discountedSalesPrice.value;
//     }
//     let discountPrice = 0;
//     let salesPrice = Number(price.value);
//     // let categoryId = props?.item?.categoryIds[0].replaceAll("-", "");
//     let categoryIds = props?.item?.categoryIds;

//     if (globalDiscountStore?.discounts?.length) {
//         globalDiscountStore.discounts.forEach(element => {
//             let discount = element.discountType === 'PERCENTAGE' ? Math.floor(salesPrice - salesPrice * Number(element.value) / 100) : salesPrice - Number(element.value);
            
//             if (element.type === 'FIXED_CATEGORY' && element.valid) {
//                 categoryIds.forEach(categoryId => {
//                     let findItem = element?.categories?.length && element.categories.filter(i=> i.categoryId.replaceAll("-", "") === categoryId.replaceAll("-", ""));
//                     if (findItem.length) {
//                         discountPrice = discount;
//                     }
//                 });
//             }

//             if (element.type === 'FIXED_PRODUCT' && element.valid) {
//                 let findItem = element?.items?.length && element.items.filter(i=> i.itemId === props.item.id && !i?.skuCode?.length);
//                 if (findItem.length) {
//                     discountPrice = discount;
//                 }
//             }
//         });
//     }

//     return discountPrice;
// });
const total = computed(() => {
        let discountedPrice = 0;
    let salesPrice = 0;
    if (globalDiscount.value > 0) {
        discountedPrice = Number(globalDiscount.value);
    }
   if (price.value > 0) {
        salesPrice = Number(price.value);
    }
    return {
        discountedPrice: globalDiscount.value,
        salesPrice: price.value,
    };
});
// const total = computed(() => {
//     let discountedPrice = 0;
//     let salesPrice = 0;
//     if (currenciesStore?.country?.currency != "BDT" &&
//         currenciesStore?.country?.rate > 0
//     ) {
//         // if (globalDiscount.value > 0) {
//         //     discountedPrice = (
//         //         Number(globalDiscount.value) /
//         //         Number(currenciesStore.country.rate)
//         //     ).toFixed(2);
//         // }
//         if (price.value > 0) {
//             salesPrice = (
//                 Number(price.value) /
//                 Number(currenciesStore.country.rate)
//             ).toFixed(2);
//         }
//     } else {
//         // if (globalDiscount.value > 0) {
//         //     discountedPrice = Number(globalDiscount.value);
//         // }
//         if (price.value > 0) {
//             salesPrice = Number(price.value);
//         }
//     }

//     return {
//         discountedPrice: discountedPrice,
//         salesPrice: salesPrice,
//     };
// });
</script>

<style lang="scss" scoped>
.card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15); // smooth shadow
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2); // stronger on hover
  }
}
.product-image-a {
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;   // vertical center
  justify-content: center; // horizontal center
  overflow: hidden;
  margin: 0 auto; // centers the container inside card if needed
  background: #f9f9f9; // optional light background for consistency

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain; // keep full image inside box
    display: block;
  }
}

.wish-link {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    line-height: 35px;
    margin-left: 15px;
    display: inline-block;

    i:hover {
        color: #f55050;
    }

    .fa-heart-o {
        display: block;
        color: rebeccapurple;
    }

    .fa-heart {
        display: block;
    }

    &:hover {
        .fa-heart-o {
            display: none;
        }

        .fa-heart {
            display: block;
            color: #f55050;
        }
    }
}

.active {
    i {
        color: #f55050;
    }

    .fa-heart-o {
        display: none !important;
    }

    .fa-heart {
        display: block !important;
    }

    svg {
        path {
            fill: #f55050;
            stroke: #f55050;
        }
    }
}

.card-tag {
    top: 20px;
    left: 20px;
}

.colors-container {
    .each-color {
        width: 25%;
        height: 20px;
    }
}

.product-bg-img {
    transition: all 0.1s ease-out;

    .even-first {
        display: block;
    }

    .odd-last {
        display: none;
    }

    &:hover {
        transition: all 0.1s ease-in-out;

        .even-first {
            display: none;
        }

        .odd-last {
            display: block;
        }
    }
}

.card {
    transition: all .3s ease-out;
}

.card:hover {
    -webkit-box-shadow: 0px 1px 21px 0px #e6e6e6;
    box-shadow: 0 1px 21px #e6e6e6;
    z-index: 1000;
    transition: all .3s ease-in;
}

@media screen and (max-width: 600px) {

    // .card-body {
    //     justify-content: flex-start !important;
    //     align-items: flex-start;
    // }
    .card-title {
        font-size: 14px;
    }

    .card-text {
        font-size: 14px;
    }
}
</style> -->

